<template>
  <div class="mid_search_but_wrap_resp">
    <a
      href="#"
      @click.stop.prevent="onOpen"
      class="mid_search_but seasidetms_header_search_but seasidetms_icon_custom_search"
    ></a>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'HeaderSearchMobile',
  methods: {
    onOpen() {
      this.setSearchMobile(true)
    },
    ...mapMutations(['setSearchMobile']),
  },
}
</script>

<style></style>
